import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import userImg from '../images/user.png'
import userIcon from '../images/user-outer.png'
import reportImg from '../images/report-icon.png'
import calenderImg from '../images/calender-icon.png'
import Camera from '../images/photo-camera.png'
import rightBtn from '../images/right-arrow.png'
import EditIcon from '../images/edit.png'
import LogoutIcon from '../images/logout.png'
import { useLocation } from "react-router-dom";
import DatePicker from "react-datepicker";
import { MdDownload } from "react-icons/md";
import html2pdf from "html2pdf.js";
import "react-datepicker/dist/react-datepicker.css";
import InvestmentAccountActivityReport from '../pages/Investment-account-activity-report-pdf1'
import RealizedGainorLoss from '../pages/realized-gain-loss-pdf';
import "react-modern-calendar-datepicker/lib/DatePicker.css";

import callingAPI from "../service"
import TransactionDetailsPdf from "../pages/transaction-details-pdf";
import StatementoffinancialholdingsPdf from '../pages/statement-of-financial-holding-pdf'
import StatementoffinancialholdingsPdf2 from '../pages/statement-of-financial-holding-pdf2'
import ChangeProfilePhoto from "./changeProfilePic-popup";
import loadingImage from '../images/login-shape.png'
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setReportData } from "../redux/reducers/reportSlice";
import { setDashboardData } from "../redux/reducers/dashboardSlice";

const options = [
    { value: 'Dashboard' },
    { value: 'Portfolio Summary' },
    { value: 'Cash Summary' },
    { value: 'Transaction' },
    { value: 'Realized' }]

export default function HeaderProfile({ onReportChange = () => { }, handleAccountData, dashboardHandleChange }) {
    const dispatch = useDispatch();
    const reportRef = useRef(null);
    const dashboardDetails = useSelector((state) => state.Dashboard);
    const customSelectRef = useRef(null);
    const accountRef = useRef(null);
    const [startDate, setStartDate] = useState(dashboardDetails.fromDate ? dashboardDetails.fromDate : new Date());
    const [toDate, setToDate] = useState(dashboardDetails.toDate ? dashboardDetails.toDate : new Date());
    const [dateDashboard, setDateDashboard] = useState(dashboardDetails.porfolioDashDate ? dashboardDetails.porfolioDashDate : new Date());
    const [showDatePicker, setShowDatePicker] = useState(dashboardDetails.reportValue === "Dashboard" || dashboardDetails.reportValue === "Portfolio Summary" || dashboardDetails.dashboardClick === "Dashboard" ? true : false);
    const [selectedReport, setSelectedReport] = useState(dashboardDetails.reportValue ? dashboardDetails.reportValue : "Dashboard");
    const navigate = useNavigate();
    const [accountList, setAccountList] = useState([])
    const [selectedClientId, setSelectedClientId] = useState('');
    const [showOptions, setShowOptions] = useState(false);
    const [showAccount, setShowAccount] = useState(false);
    const [hoveredReport, setHoveredReport] = useState(null);
    const [hoveredAccount, setHoveredAccount] = useState(null);
    const location = useLocation();
    const isProfilePage = location.pathname === '/my-profile';
    const lastSegment = location.pathname.split('/').filter(Boolean).pop();
    const [selectedDay, setSelectedDay] = useState();
    const [clientIdSet, setClientIdSet] = useState(dashboardDetails.clientid)
    const [clientNameSet, setClientNameSet] = useState(dashboardDetails.clientname)
    const [isChngePassModalOpen, setChngePassModalOpen] = useState(false);
    const [isSaveButton, setIsSaveButton] = useState(false);
    const [avatarUrl, setAvatarUrl] = useState('');
    const refreshToken = dashboardDetails.refreshToken
    const [pdfData, setPdfData] = useState(false)
    const [searchFlag, setSearchFlag] = useState(false)
    const [loaderFlag, setLoaderFlag] = useState(true)
    const [hasMarketValue, setHasMarketValue] = useState("")
    const userId = dashboardDetails.userId;
    const clientName = dashboardDetails.clientname;
    const marginFlags = dashboardDetails.marginFlag;
    const currentDate = new Date();
    const minDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 15, currentDate.getDate());
    const maxDate = new Date();

    const isMonthDisabled = (month, selectedYear) => {
        const minYear = minDate.getFullYear();
        const maxYear = maxDate.getFullYear();
        const minMonth = minDate.getMonth();
        const maxMonth = maxDate.getMonth();

        if (selectedYear === minYear && month < minMonth) return true;
        if (selectedYear === maxYear && month > maxMonth) return true;
        return false;
    };

    const renderCustomHeader = ({ date, changeYear, changeMonth }) => {
        const selectedDate = new Date(date); // Ensure it's a Date object

        return (
            <div>
                {/* Custom header to show selected month and year */}
                <div className="react-datepicker__header">
                    <span>
                        {selectedDate.toLocaleString("default", { month: "long" })} {selectedDate.getFullYear()}
                    </span>
                </div>

                <div>
                    <select
                        value={selectedDate.getFullYear()}
                        onChange={({ target: { value } }) => changeYear(parseInt(value, 10))}
                    >
                        {[...Array(maxDate.getFullYear() - minDate.getFullYear() + 1)].map((_, i) => (
                            <option key={i} value={minDate.getFullYear() + i}>
                                {minDate.getFullYear() + i}
                            </option>
                        ))}
                    </select>

                    <select
                        value={selectedDate.getMonth()}
                        onChange={({ target: { value } }) => changeMonth(parseInt(value, 10))}
                    >
                        {[...Array(12)].map((_, month) => (
                            <option
                                key={month}
                                value={month}
                                disabled={isMonthDisabled(month, selectedDate.getFullYear())}
                            >
                                {new Date(0, month).toLocaleString("default", { month: "long" })}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
        );
    };

    useEffect(() => {
        fetchAvatar();

    }, []);

    const fetchAvatar = async () => {
        try {
            const postData = {
                userId: userId,
                // //"refreshToken": refreshToken
            };
            const response = await callingAPI(postData, "uploads/getAvatar");
            console.log("🚀 ~ fetchAvatar ~ response:", response);
            // if (response.data.statusCode === 200) {
            //     console.log("🚀 ~ fetchAvatar ~ response.data.avatarUrl:", response);
            //     const avatarData = response.data.data[0].avatar.data;
            //     const base64String = btoa(String.fromCharCode(...avatarData));
            //     const fetchedAvatarUrl = `data:image/png;base64,${base64String}`;
            //     setAvatarUrl(fetchedAvatarUrl);
            // } 
            if (response.data.statusCode === 200) {
                const avatarData = response.data.data[0].avatar.data; // Uint8Array
                const blob = new Blob([new Uint8Array(avatarData)], { type: "image/png" });

                const reader = new FileReader();
                reader.onloadend = () => {
                    setAvatarUrl(reader.result); // base64 image string
                };
                reader.readAsDataURL(blob); // ✅ works for large images too
            }
            else {
                console.error('Failed to fetch avatar. Status code:', response.status);
            }
        } catch (error) {
            console.error('Error fetching avatar:', error);
        }
    };

    var formattedToDate
    var formattedStartDate
    useEffect(() => {
        formattedStartDate = new Date(startDate).toISOString().split('T')[0];
        formattedToDate = new Date(toDate).toISOString().split('T')[0];
        handleAccountList();
        const clientIdFromStorage = clientIdSet;
        const clientNameFromStorage = clientNameSet;
        if (clientIdFromStorage) {
            setSelectedClientId(clientIdFromStorage + "-" + clientNameFromStorage);
        }
        const handleClickOutside = (event) => {
            if (customSelectRef.current && !(customSelectRef.current.contains(event.target))) {
                setShowOptions(false);
            }
            if (accountRef.current && !(accountRef.current.contains(event.target))) {
                setShowAccount(false);
            }
        };
        document.addEventListener("click", handleClickOutside);
        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, [])

    const viewreport = async () => {
        try {

            dispatch(setDashboardData({
                hasMarket: hasMarketValue,
                clientid: clientIdSet,
                clientname: clientNameSet
            })
            )
            setLoaderFlag(false)
            setSearchFlag(true)
            if (!dateDashboard) {
                console.warn("Date not selected");
                return;
            }

            const formattedDate = dateDashboard ? new Date(dateDashboard).toISOString().split('T')[0] : new Date(dateDashboard).toISOString().split('T')[0];
            formattedStartDate = startDate ? new Date(startDate).toISOString().split('T')[0] : new Date(startDate).toISOString().split('T')[0];
            formattedToDate = toDate ? new Date(toDate).toISOString().split('T')[0] : new Date(toDate).toISOString().split('T')[0];
            if (selectedReport === "Dashboard") {
                setDateDashboard(formattedDate)
                dispatch(
                    setDashboardData({
                        previousPage: 1,
                        reportClickDateDashboard: formattedDate
                    })
                );
                setLoaderFlag(true)
                navigate("/dashboard", { state: { directFlag: false } })
            } else if (selectedReport) {
                if (selectedReport === "Portfolio Summary" && dashboardDetails.marginFlag === "Yes") {
                    dispatch(
                        setDashboardData({
                            reportClickDateDashhboard: formattedDate
                        })
                    );
                    navigate("/reports/marginPortfolio")
                }
                else if (selectedReport === "Portfolio Summary" && dashboardDetails.marginFlag === "No") {
                    dispatch(
                        setDashboardData({
                            reportClickDateDashhboard: formattedDate
                        })
                    );
                    navigate("/reports/nonMarginPortfolio")
                }
                else if (selectedReport === "Cash Summary") {
                    if (new Date(formattedStartDate) > new Date(formattedToDate)) {
                        alert("To Date must be greater than or equal to From Date");
                        setLoaderFlag(true);
                        return;
                    }
                    dispatch(
                        setDashboardData({
                            reportClickFromDate: formattedStartDate,
                            reportClickToDate: formattedToDate
                        })

                    );
                    navigate("/reports/cashReport")
                }
                else if (selectedReport === "Transaction") {
                    if (new Date(formattedStartDate) > new Date(formattedToDate)) {
                        alert("To Date must be greater than or equal to From Date");
                        setLoaderFlag(true);
                        return;
                    }
                    dispatch(
                        setDashboardData({
                            reportClickFromDate: formattedStartDate,
                            reportClickToDate: formattedToDate
                        })
                    );
                    navigate("/reports/transaction")
                }
                else {
                    if (new Date(formattedStartDate) > new Date(formattedToDate)) {
                        alert("To Date must be greater than or equal to From Date");
                        setLoaderFlag(true);
                        return;
                    }
                    dispatch(
                        setDashboardData({
                            reportClickFromDate: formattedStartDate,
                            reportClickToDate: formattedToDate,
                            externalAPI: true
                        })
                    );
                    navigate("/reports/realized")
                }

                setTimeout(() => {
                    setSearchFlag(false)
                    setLoaderFlag(true)

                }, 2000); // 2-second delay
                setIsSaveButton(new Date())
                setPdfData(true)
            }
        } catch (error) {
            console.error('Error during profile fetch:', error);
        }
    };

    const handleReportChange = (selectedOption) => {
        setSelectedReport(selectedOption.value);
        setPdfData(false)
        setStartDate(new Date())
        setToDate(new Date())
        dispatch(
            setDashboardData({
                reportValue: selectedOption.value,
                dashboardClick: selectedOption.value,
                fromDate: new Date(),
                porfolioDashDate: new Date(),
                toDate: new Date()
            })
        )
        if (selectedOption.value === "Dashboard" || selectedOption.value === "Portfolio Summary") {
            setShowDatePicker(true);
            // setDateDashboard(new Date());
            dispatch(setDashboardData({ fromDate: new Date() })
            )
        } else {
            setShowDatePicker(false);
        }
    };

    const handleDownload = async () => {
        try {
            console.log("🚀 ~ handleDownload ~ reportRef?.current:", reportRef?.current)
            if (!reportRef?.current) {
                console.warn("Report ref is not set");
                return;
            }
            const element = reportRef.current;
            const currentDate = new Date().toLocaleDateString('en-GB').replace(/\//g, '-');
            // Determine the filename
            let filename = `${selectedReport}_${currentDate}.pdf`;
            if (selectedReport === "Portfolio Summary") {
                if (marginFlags === "Yes") {
                    filename = `Margin Client Holding_${currentDate}.pdf`;
                } else if (marginFlags === "No") {
                    filename = `Non Margin Client Holding_${currentDate}.pdf`;
                }
            }
            const options = {
                margin: [0, 0, 0, 0],
                filename: filename,
                image: { type: "jpeg", quality: 0.98 },
                html2canvas: {
                    scale: 2,
                    useCORS: true,
                    logging: false, // Reduce console logging
                    allowTaint: true
                },
                jsPDF: { unit: "in", format: "a4", orientation: "landscape" },
            };
            // Use Promise-based approach with timeout to allow UI updates
            // await new Promise(resolve => setTimeout(resolve, 200)); // Allow UI update

            await html2pdf().from(element).set(options).save();

        } catch (error) {
            console.error("Error generating PDF:", error);
        } finally {

        }
    };

    const handleAccountList = () => {
        if (!userId) {
            console.error('Client ID not found.');
            return;
        }
        const postData = {
            "userId": userId,
            // //"refreshToken": refreshToken

        };
        callingAPI(postData, "user/accountList", 'post')
            .then((response) => {
                console.log("🚀 ~ .then ~ response:", response)
                const { data } = response;
                if (data.statusCode === 200) {
                    setAccountList(data.data || []);
                } else {
                    console.error('Failed to fetch profile details:', data.message);
                }
            })
            .catch((error) => {
                console.error('Error during profile fetch:', error);
            });

    }
    const handleChange = (data) => {
        setSelectedClientId(data.clientid + "-" + data.clientname);
        setPdfData(false)
        setClientIdSet(data.clientid)
        setHasMarketValue(data.hasMarket);
        setClientNameSet(data.clientname)
        dispatch(
            setDashboardData({
                clientid: data.clientid,
                clientname: data.clientname,
                hasMarket: data.hasMarket,
                marginFlag: data.marginflag,
                externalAPI: true
            })
        )

    };

    const toggleOptions = () => {
        setShowOptions(prev => !prev);
    };
    const toggleAccount = () => {
        setShowAccount(prev => !prev);
    };
    const handleMouseOver = (option) => {
        setHoveredReport(option.value);
    };

    const handleMouseLeave = () => {
        setHoveredReport(null);
    };
    const handleMouseOverAccount = (option) => {
        setHoveredAccount(option.clientid + "-" + option.clientname);
    };

    const handleMouseLeaveAccount = () => {
        setHoveredAccount(null);
    };
    const confirmOpenPopup = () => {
        setChngePassModalOpen(true); // Open the modal
    };

    const cancelOpenPopup = () => {
        setChngePassModalOpen(false); // Close the modal
        fetchAvatar();
    };

    return (


        <div>
            {loaderFlag ?

                <div className="profile-header">
                    <div className="container-fluid">
                        <div className="profile-inner">
                            <div className="profile-left  profile-set-left">
                                <div className="profile-left-img">
                                    {avatarUrl ? <img src={avatarUrl} width={60} height={60} className="img-fluid avatar-img" alt="user" />
                                        : <img src={userImg} width={45} height={45} className="img-fluid" alt="user" />}
                                    <img src={Camera} width={20} height={20} className="img-fluid prof-camImg" alt="camera" onClick={confirmOpenPopup} />
                                </div>
                                <span className="profile-text" title={clientName}
                                    style={{
                                        fontSize:
                                            (clientName)?.length > 30 ? "12px" : "15px",
                                    }}
                                >{clientName}</span>
                            </div>
                            <div className="profile-right">
                                {isProfilePage ? (
                                    <div className="header-logoutsec">
                                        {/* <button className="btn-edit-header"><img src={EditIcon} alt="" className="img-fluid m-right" />Edit</button> */}
                                        {/* <a className="btn-Logout-header text-decoration-none" onClick={()=>handleLogout()}><img src={LogoutIcon} alt="" className="img-fluid btn-Logout-header-img m-right" />Logout</a> */}
                                    </div>
                                ) : (
                                    <ul className="profile-ul">
                                        <li className="profile-li">
                                            <img src={userIcon} className="img-fluid profile-li-img" width={14} height={14} alt="user" />
                                            <span className="profile-span">Account</span>
                                            <div ref={accountRef} class="curved-select-container">
                                                <div class="custom-select curved-select" onClick={toggleAccount}>
                                                    <span class="selected-value" title={selectedClientId}> {hoveredAccount ? hoveredAccount : selectedClientId}</span>
                                                    {showAccount && (
                                                        <div className="options-container">
                                                            {accountList && accountList.map((account) =>
                                                                <div
                                                                    key={account.clientid} value={account.clientid}
                                                                    className={`option`}
                                                                    onClick={() => handleChange(account)} onMouseOver={() => handleMouseOverAccount(account)}
                                                                    onMouseLeave={handleMouseLeaveAccount}
                                                                >
                                                                    {console.log("account", account)}
                                                                    {account.clientid} - {account.clientname}
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </li>
                                        <li className="profile-li profile-li-report">
                                            <img src={reportImg} className="img-fluid profile-li-img" width={14} height={14} alt="user" />
                                            <span className="profile-span">Report</span>
                                            <div ref={customSelectRef} class="curved-select-container">
                                                <div class="custom-select curved-select" onClick={toggleOptions}>
                                                    <span class="selected-value" title={selectedReport}>{hoveredReport ? hoveredReport : selectedReport}</span>
                                                    {showOptions && (
                                                        <div className="options-container">
                                                            {console.log("options", options)}
                                                            {options.map((option) => (
                                                                <div
                                                                    key={option.value}
                                                                    className={`option ${selectedReport && selectedReport === option.value ? 'option-select' : ''}`}
                                                                    onClick={() => handleReportChange(option)} onMouseOver={() => handleMouseOver(option)}
                                                                    onMouseLeave={handleMouseLeave}
                                                                >
                                                                    {option.value}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </li>
                                        {showDatePicker ? (
                                            <li className="profile-li profile-li-to profile-li-date date-names">
                                                <img src={calenderImg} className="img-fluid profile-li-img" width={14} height={14} alt="user" />
                                                <span className="profile-span">Date</span>

                                                <DatePicker
                                                    selected={dateDashboard}
                                                    dateFormat="dd/MM/yyyy"
                                                    onChange={(date) => {
                                                        setDateDashboard(date); // Update local state

                                                        const today = new Date().toISOString().split("T")[0]; // Get current date (YYYY-MM-DD)
                                                        const selectedDate = date.toISOString().split("T")[0]; // Convert selected date

                                                        dispatch(setDashboardData({
                                                            porfolioDashDate: date,
                                                            externalAPI: selectedDate !== today ? true : false // Set externalAPI based on date comparison
                                                        }));
                                                    }}
                                                    className="profile-curved"
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    scrollableYearDropdown
                                                    scrollableMonthDropdown
                                                    minDate={minDate}
                                                    maxDate={maxDate}
                                                    renderCustomHeader={renderCustomHeader}
                                                    onKeyDown={(e) => e.preventDefault()}
                                                />
                                            </li>
                                        ) : (
                                            <>
                                                <li className="profile-li profile-li-ex">
                                                    <img src={calenderImg} className="img-fluid profile-li-img" width={14} height={14} alt="user" />
                                                    <span className="profile-span">From</span>
                                                    <DatePicker
                                                        selected={startDate}
                                                        dateFormat="dd/MM/yyyy"
                                                        onChange={(date) => {
                                                            setStartDate(date);
                                                            dispatch(setDashboardData({
                                                                fromDate: date
                                                            }))
                                                        }}
                                                        className="profile-curved"
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        scrollableYearDropdown
                                                        scrollableMonthDropdown
                                                        yearDropdownItemNumber={201}
                                                        minDate={minDate}
                                                        maxDate={new Date()}
                                                        renderCustomHeader={renderCustomHeader}
                                                        onKeyDown={(e) => e.preventDefault()}
                                                    />
                                                </li>
                                                <li className="profile-li profile-li-to date-names">
                                                    <img src={calenderImg} className="img-fluid profile-li-img" width={14} height={14} alt="user" />
                                                    <span className="profile-span">To</span>
                                                    <DatePicker
                                                        selected={toDate}
                                                        dateFormat="dd/MM/yyyy"
                                                        onChange={(date) => {
                                                            setToDate(date);
                                                            dispatch(setDashboardData({
                                                                toDate: date
                                                            }))
                                                        }}
                                                        className="profile-curved"
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        scrollableYearDropdown
                                                        scrollableMonthDropdown
                                                        yearDropdownItemNumber={201}
                                                        minDate={minDate}
                                                        maxDate={new Date()}
                                                        renderCustomHeader={renderCustomHeader}
                                                        onKeyDown={(e) => e.preventDefault()}
                                                    />
                                                </li>
                                            </>
                                        )}
                                        <li className="profile-li profile-li-btn" onClick={() => viewreport()}>
                                            {/* {searchFlag ? <span className="profile-view" style={{color:"#223C6C",height:"32px"}}> Please Wait</span>
                                        :  */}
                                            <span className="profile-view"> Search<img src={rightBtn} className="img-fluid" width={24} height={24} alt="view" /> </span>
                                            {/* } */}

                                        </li>
                                        {lastSegment !== "dashboard" ?
                                            <button className="download-btn" onClick={handleDownload}>
                                                <MdDownload color="#fff" />
                                            </button>
                                            : ""}
                                    </ul>
                                )}
                            </div>
                        </div>
                    </div>
                    <div key={isSaveButton}>

                        {selectedReport === "Cash Summary" &&
                            <div style={{ display: "none" }}>
                                <InvestmentAccountActivityReport key={isSaveButton} ref={reportRef} fromDate={startDate}
                                    toDate={toDate} />
                            </div>}
                        {selectedReport === "Realized" &&
                            <div style={{ display: "none" }}>
                                <RealizedGainorLoss ref={reportRef} key={isSaveButton} fromDate={startDate}
                                    toDate={toDate} />
                            </div>}
                        {selectedReport === "Transaction" &&
                            <div style={{ display: "none" }}>
                                <TransactionDetailsPdf ref={reportRef} key={isSaveButton} fromDate={startDate} toDate={toDate} />
                            </div>}
                        {selectedReport === "Portfolio Summary" && dashboardDetails.marginFlag === "Yes" &&
                            <div style={{ display: "none" }}>
                                <StatementoffinancialholdingsPdf ref={reportRef} key={isSaveButton} fromDate={dateDashboard} toDate={toDate} selectedStartDate={formattedStartDate} />
                            </div>}
                        {selectedReport === "Portfolio Summary" && dashboardDetails.marginFlag === "No" &&
                            <div style={{ display: "none" }}>
                                <StatementoffinancialholdingsPdf2 ref={reportRef} key={isSaveButton} fromDate={dateDashboard} toDate={toDate} />
                            </div>}

                    </div>
                    <ChangeProfilePhoto
                        isOpen={isChngePassModalOpen}
                        onClose={cancelOpenPopup}
                        onConfirm={confirmOpenPopup}
                    />
                </div>
                :
                <div className="d-flex justify-content-center align-items-center loading-container loading-allcontainer">
                    <div className="spinner-container">
                        <div className="spinner-border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <img src={loadingImage} alt="Loading..." className="loading-image" />
                    </div>
                </div>


            }</div>



    )
}
